import { Link } from 'components/Atoms/Link'
import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { CONTENT_TYPES } from 'constants/games/contentTypes'
import { LONG_DASH } from 'constants/index'
import { useMemo } from 'react'
import { currencyFormatter } from 'utils'

export const UserAchievementInfo = ({ loading, achievementUser, scrollToTiersRef }) => {
  const pointsNeededForNext = useMemo(() => {
    if (!achievementUser) return LONG_DASH
    const totalPoints = achievementUser.totalPoint
    const nextPoints = achievementUser.nextLevelInfo?.xp_requirement || 0
    const diffPoints = nextPoints - totalPoints
    if (diffPoints < 0) return LONG_DASH
    return currencyFormatter(diffPoints, { decimalDigits: 0, noCurrencySign: true })
  }, [achievementUser])

  return (
    <div className='ach_current_box'>
      <div className='ach_current_status_wrapper'>
        <div className='intro'>Current level:</div>
        <div
          className='ach_current_status tier_indicator '
          style={
            loading
              ? {}
              : {
                  background: achievementUser.color.replace('hsl', 'hsla').replace('%)', '%, .1)'),
                  border: `1px solid ${achievementUser.color.replace('hsl', 'hsla').replace('%)', '%, .4)')}`,
                }
          }
        >
          <div className='tier_name'>
            <strong>
              <SingleDataLoader loading={loading} data={achievementUser?.name} />
            </strong>
            <div onClick={scrollToTiersRef}>(see all tiers)</div>
          </div>
          <div
            className='badge_icon level_icon'
            style={
              loading
                ? {}
                : {
                    background: `url(${achievementUser.icon}) center center / 20px auto no-repeat`,
                  }
            }
          ></div>
        </div>
      </div>

      <div className='ach_current_status_wrapper total_points'>
        <div className='intro'>Total points:</div>
        <div className='ach_current_status'>
          <div className='ach_points'>
            <SingleDataLoader
              loading={loading}
              data={
                <>
                  <strong>
                    {currencyFormatter(achievementUser?.totalPoint, { decimalDigits: 0, noCurrencySign: true })}
                  </strong>{' '}
                  XP
                </>
              }
            />
          </div>
        </div>
      </div>

      <div className='ach_current_status_wrapper points_needed'>
        <div className='intro'>Needed for next level:</div>
        <div className='ach_current_status'>
          <div className='ach_points'>
            <strong>{pointsNeededForNext}</strong> XP
          </div>
        </div>
      </div>

      <div className='ach_current_status_wrapper coming_soon'>
        <div className='intro'>Rewards earned:</div>
        <div className='ach_current_status'>
          <div className='ach_points'>
            {/* <strong>{currencyFormatter(0)}</strong> */}
            <strong>Coming soon</strong>
            Rewards will be available when <Link to={`/game/${CONTENT_TYPES.YOLO_TOKEN}`}>
              $YOLO public issuance
            </Link>{' '}
            is complete.
          </div>
        </div>
      </div>

      <div class='ach_current_status_wrapper coming_soon'>
        <div class='intro'>$YOLO earned:</div>
        <div class='ach_current_status'>
          <div class='ach_yolo_tokens'>
            <strong>Coming soon</strong>Earned $YOLO will be available when{' '}
            <Link to={`/game/${CONTENT_TYPES.YOLO_TOKEN}`}>$YOLO public issuance</Link> is complete.
            {/* <!-- <div class="yolo_token size_40"></div> --> */}
          </div>
        </div>
      </div>
    </div>
  )
}
